export enum ElementId {
  TextInput = 'textInput',
  CopyButton = 'copyButton',
}
